import React, { memo } from 'react';
import LazyImage from '../../../../components/CustomLibraries/LazyImage';

const FormSteps = ({ nextPrev, onNextBtnClick }) => {
  return (
    <div className="dt_profile_setup dt_ProfileManagement text-center">
      {/* <div className="doctubeLogo mb-4 mx-auto">
        <LazyImage src="https://ik.imagekit.io/doctube/logo.svg" className="mw-100 mh-100 w-auto h-auto" />
      </div> */}
      <h1 className="text-black fs-3 fw-medium mb-3">Let's put your public profile together</h1>
      <ul className="dt_stepNav mx-auto mb-5 position-relative ps-0 list-unstyled list-inline">
        {[1, 2, 3].map((_i, idx) => (
          <li
            className={`list-inline-item position-relative mx-3 mx-md-4 ${
              nextPrev == _i ? 'active' : 'completed'
            }`}
            key={idx + 1}
          >
            <a
              href="javascript:void(0)"
              className="fs-4 fw-medium text-dark bg-white border border-dark rounded-circle d-flex justify-content-center align-items-center position-relative z-1"
              onClick={() => onNextBtnClick(_i)}
            >
              {_i}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default memo(FormSteps);
